import type { CycleEvaluationGroup } from '@/types/cycle-evaluation/CycleEvaluationGroup';

import { CycleEvaluationGroupStatus } from '@/types/cycle-evaluation/CycleEvaluationGroup';

/**
 * Whether a feedback cycle has already been launched, i.e. it is no longer a draft being built.
 *
 * The stepper behaves differently on each side of that line. A DRAFT is being created: every step
 * validates and saves on "Next", and a date in the past refuses the step outright, so the cycle
 * cannot be launched over dates that have already gone by. A LAUNCHED cycle is being consulted or
 * edited: while nothing has been touched, "Next" writes nothing and refuses nothing, so an
 * administrator can walk through every step of a live cycle whose dates have naturally gone past.
 * The moment one field is edited, the step validates and saves again as it did during creation.
 *
 * Derived from the status on every render, like `isCycleEvaluationGroupReadOnly`: `Completed`
 * is read-only and handled before this predicate is ever consulted.
 */
export const isCycleEvaluationGroupLaunched = (group?: CycleEvaluationGroup | null): boolean =>
    !!group && group.status !== CycleEvaluationGroupStatus.DRAFT;
